<template>
    <div 
        :class="alertMarginClass"
        class="margin-top"
    >
        <vs-breadcrumb
            class="block md:hidden"
            :items="breadcrumbItems"
            separator="chevron_right"
        />
        <h1 class="pb-3">Fresh Summit</h1>
        <vs-breadcrumb
            class="hidden md:block mb-10"
            :items="breadcrumbItems"
            separator="chevron_right"
        />
        <div class="bg-opacity-100 w-full min-h-screen">
            <div
                v-for="items, index in JsonData.cards" :key="index"
                :class="`grid ${items.length > 1 ? 'grid-cols-2' : 'grid-cols-1'}`"
            >
                <div
                    v-for="(card, cardIndex) in items"
                    :key="cardIndex"
                    class="p-6 flex flex-col border border-solid justify-center"
                    style="border-color: #e5e7eb"
                >
                <img
                    class="w-full hidden md:block"
                    :src="card.desktop_image_url"
                    alt="Promotion Image"
                    @click="redirectToURL(card.image_link)"
                />
                <img
                    class="w-full md:hidden"
                    :src="card.mobile_image_url"
                    alt="Promotion Image"
                    @click="redirectToURL(card.image_link)"
                />
                <h3 class="pt-4">{{ card.title }}</h3>
                <div v-if="card.description">{{ card.description }}</div>
                <div v-if="card.link && card.button_text" class="w-full h-full flex justify-center items-end mt-8">
                    <vs-button @click="redirectToURL(card.link)" class="mb-3">
                        {{ card.button_text }}
                    </vs-button>
                </div>
                <div v-if="card.link && !card.button_text" class="w-full h-full flex justify-center items-end mt-8">
                    <vs-button @click="redirectToURL(card.link)" class="mb-3">
                    Explore
                    </vs-button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            JsonData: {},
        };
    },
    computed: {
        alertMarginClass() {
            return this.$store.state.eCommerce.showAlertHeader ? 'p-2 md:mt-0 mt-0' : 'p-2';
        },
        breadcrumbItems() {
            return [
                { title: 'Home', url: '/'+this.$getUserType()+'/shop' },
                { title: 'Fresh Summit', active: true },
            ];
        },
    },
    methods: {
        ...mapActions('eCommerce', ['getJsonSettings', 'productFilterListing']),
        async fetchJsonSettings() {
            try {
                const response = await this.getJsonSettings({ slug: 'fresh-summit' });
                this.JsonData = response.data.data;
            } catch (error) {
                console.error('Error fetching JSON settings:', error);
            }
        },
         redirectToURL(url) {
            if (typeof window !== 'undefined' && url) {
                window.location.href = this.$replaceUrlTemplate(url, this.$getUserType());
            }
        },
    },
    async created() {
        await this.fetchJsonSettings();
    },
};
</script>

<style>
@media only screen and (max-width: 768px) {
    .margin-top{
        margin-top: 63px !important
    }
}
</style>
